import { Help as HelpIcon } from '@mui/icons-material';
import { AppBar, Box, IconButton, Toolbar } from '@mui/material';
import { useFeatureFlags } from 'apps/wrapper/src/hooks/feature-flags/use-feature-flags';
import { useLocations } from 'apps/wrapper/src/hooks/use-locations';
import { ReactElement } from 'react';
import { ReactComponent as RwLogoFull } from '../../../../assets/logo.svg';
import config from '../../../../config/config.json';
import { useEventBus } from '../../../../hooks/use-event-bus/use-event-bus';
import { useViewMode } from '../../../../hooks/use-view-mode';
import AlertButton from './alert-button';
import InboxButton from './inbox-button';
import { LocationSelection } from './location-selection/location-selection';
import { SearchBar } from './search-bar/search-bar';
import SettingsButton from './settings-button';
import { TopNavMobile } from './top-nav-mobile';
import { TopNavTablet } from './top-nav-tablet';
import UserButton from './user-button';

const TopNav = (): ReactElement => {
  const { viewMode } = useViewMode();
  const isTablet = viewMode === 'Tablet';
  const isPhone = viewMode === 'Phone';
  const { publish } = useEventBus();
  const { hasFeature } = useFeatureFlags();
  const { selectedLocation } = useLocations();

  const hasAlerts = hasFeature(selectedLocation?.id!, 'Alerts2');
  const hasUnifiedInbox = hasFeature(selectedLocation?.id!, 'UnifiedInbox');

  if (isPhone) return <TopNavMobile />;

  if (isTablet) return <TopNavTablet />;

  return (
    <AppBar position="relative" sx={{ backgroundColor: 'nav.main', boxShadow: 'none' }}>
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        <Box>
          <RwLogoFull />
        </Box>
        <LocationSelection />

        <Box width="40%" display="flex" sx={{ zIndex: 1, margin: 'auto' }}>
          <SearchBar visible={true} onClose={() => {}} />
        </Box>

        <Box display="flex" alignItems="center">
          {hasUnifiedInbox && <InboxButton />}
          {hasAlerts && <AlertButton />}
          <Box sx={{ width: '2px', height: '48px', backgroundColor: 'nav.dark' }} />
          <SettingsButton />

          <IconButton
            sx={{
              width: 48,
              height: 48,
              margin: '11px 0 11px 0px',
              borderRadius: 12,
              color: '#fff',
              '&:hover': {
                backgroundColor: '#265D7C'
              },
              '&:focus-visible': {
                border: '2px solid #1EB9FB'
              },
              '&.MuiIconButton-root': {
                color: '#80979F'
              },
              '&.MuiIconButton-root:hover': {
                backgroundColor: '#032F40',
                color: '#ffffff'
              }
            }}
            onClick={() => {
              publish({
                messageType: 'navigate',
                data: {
                  pathname: config.support.url,
                  crossFrame: true,
                  replaceState: false
                }
              });
            }}
          >
            <HelpIcon />
          </IconButton>
          <UserButton />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default TopNav;
